export default "__VITE_ASSET__uVcHXAlK__"